import {UyapRequest} from "./UyapRequest";

export interface IllerIlcelerTalep {
}

export type IllerIlcelerCevap = Array<IIller>

interface IIller {
    il: string,
    ad: string,
    ilceler: Array<IIlceler>,
    kodAciklamaCiksin: string,
    bolgeId: string,
    buyuksehir: string,
    takbisIlKodu: string
}

interface IIlceler {
    ilcekod: string,
    ilcead: string,
    iladi: string,
    ilKodu: string,
    kodAciklamaCiksin: string,
    saymanlikIcinKodAciklamaCiksin: string
}

export default class IllerIlceler extends UyapRequest<IllerIlcelerTalep, IllerIlcelerCevap> {
    delayTime = 0;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24 * 7), //* 7 gun
            key: "IllerIlceler"
        };
    }

    getMockResponse(): any {
        return [{"il":"34","ad":"İSTANBUL","ilceler":[{"ilcekod":"1","ilcead":"BAKIRKÖY","iladi":"İSTANBUL","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"2","ilcead":"ADALAR","iladi":"İSTANBUL","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"41","ilcead":"SULTANGAZİ","iladi":"İSTANBUL","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"true","takbisIlKodu":"0"},{"il":"6","ad":"ANKARA","ilceler":[{"ilcekod":"1","ilcead":"ALTINDAĞ","iladi":"ANKARA","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"2","ilcead":"AKYURT","iladi":"ANKARA","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"26","ilcead":"PURSAKLAR","iladi":"ANKARA","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"true","takbisIlKodu":"0"},{"il":"35","ad":"İZMİR","ilceler":[{"ilcekod":"1","ilcead":"BAYRAKLI","iladi":"İZMİR","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"2","ilcead":"ALİAĞA","iladi":"İZMİR","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"31","ilcead":"KARABAĞLAR","iladi":"İZMİR","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"true","takbisIlKodu":"0"},{"il":"79","ad":"KİLİS","ilceler":[{"ilcekod":"1","ilcead":"KİLİS MERKEZ","iladi":"KİLİS","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"4","ilcead":"POLATELİ","iladi":"KİLİS","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"false","takbisIlKodu":"0"},{"il":"80","ad":"OSMANİYE","ilceler":[{"ilcekod":"1","ilcead":"OSMANİYE MERKEZ","iladi":"OSMANİYE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"2","ilcead":"BAHÇE","iladi":"OSMANİYE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"7","ilcead":"TOPRAKKALE","iladi":"OSMANİYE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"false","takbisIlKodu":"0"},{"il":"81","ad":"DÜZCE","ilceler":[{"ilcekod":"1","ilcead":"DÜZCE MERKEZ","iladi":"DÜZCE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"2","ilcead":"AKÇAKOCA","iladi":"DÜZCE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"},{"ilcekod":"3","ilcead":"CUMAYERİ","iladi":"DÜZCE","ilKodu":"0","kodAciklamaCiksin":"false","saymanlikIcinKodAciklamaCiksin":"false"}],"kodAciklamaCiksin":"false","bolgeId":"0","buyuksehir":"false","takbisIlKodu":"0"}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'illerIlcelerGetir.ajx';
    }

    async parse(data: any): Promise<IllerIlcelerCevap> {
        return data
    }
}
